import script from "./MessageExtrasWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageExtrasWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./MessageExtrasWrapper.vue?vue&type=style&index=0&id=81b51ad4&lang=scss"

const __exports__ = script;

export default __exports__